/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AuthManager } from "services/auth-service/auth";
import { selectCurrentUser } from "store/features";
import { useAppSelector } from "store/hooks";

export function RequireAuth({ children }: { children?: JSX.Element }) {
  const user = useAppSelector(selectCurrentUser);
  const location = useLocation();

  useEffect(() => {
    if (!user) {
      let redirect = "";

      redirect += location.pathname;

      if (location.search)
        redirect += `?${location.search}`;

      console.debug("RequireAuth AuthManager.signIn");
      void AuthManager.signIn({ redirect });
    }
  }, [location, user]);

  return children || null;
}
